import { CtaButton, Spinner } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledTextArea } from './SurveyForm.types';

export const StyledBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${rem('32px')};
`;

export const StyledFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${rem('580px')};
  gap: ${rem('24px')};

  @media (max-width: ${rem('580px')}) {
    width: 100%;
  }
`;

export const FormLabel = styled.label`
  color: #000000;
  font-family: 'Nunito';
  font-weight: 600;
  font-size: ${rem('20px')};

  @media (max-width: ${rem('580px')}) {
    font-size: ${rem('16px')};
  }
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledButton = styled(CtaButton)`
  cursor: pointer;
  display: flex;
`;

export const StyledTextArea = styled.textarea<IStyledTextArea>`
  placeholder: ${({ placeholder }) => placeholder};
  border-radius: ${rem('14px')};
  background: #fbfbfb;
  border: 1px solid #e5e5e5 !important;
  padding: ${rem('24px')};
  width: 100%;
  font-size: ${rem('16px')};
  resize: none;

  &:focus-visible {
    border: 1px solid #e5e5e5 !important;
  }

  @media (max-width: ${rem('580px')}) {
    font-size: ${rem('12px')};
  }
`;

export const StyledSpinner = styled(Spinner)`
  margin-right: ${rem('5px')};
`;
